import React, { use } from "react";
import { useAtom } from "jotai";
import ScreenCard from "../ScreenCard";
import { newMissionState } from "../../atoms/core";
import { CreateMissionScreensContext } from "../../contexts/CreateMissionManager";
import { useI18n } from "../../hooks/i18n-hooks";
import MissionWorkingAddress from "../../components/editors/MissionWorkingAddress";
import { Address } from "../../components/address/address";
import { useCurrentProfile } from "../../hooks/use-current-profile";
import { AuthManagerContext } from "../../contexts/AuthManager";
import { Bubble } from "../../components/Bubble";
import { useBubbleStepOrigin } from "../../hooks/use-bubble-step-origin";

const CreateMissionWorkingAddress = () => {
    const i18n = useI18n();
    const [mission, setMission] = useAtom(newMissionState);
    const { validateScreen } = use(CreateMissionScreensContext);
    const currentProfile = useCurrentProfile();
    const { user } = use(AuthManagerContext);
    const isPrivateClient = currentProfile?.isPrivateClient || false;

    const setWorkingAddress = React.useCallback(
        (address: Address | null) => {
            setMission((oldMission) => ({
                ...oldMission,
                currentContract: {
                    ...oldMission.currentContract,
                    useClientWorkingAddress: !isPrivateClient
                        ? address?.formatted === oldMission.clientInfo?.address?.formatted
                        : address?.formatted === user?.address?.formatted,
                    workingAddress: address,
                    cctEditionId: undefined,
                },
            }));
        },
        [isPrivateClient, setMission, user?.address],
    );
    const validate = React.useCallback(() => {
        void validateScreen("CreateMissionWorkingAddress");
    }, [validateScreen]);

    const origin = useBubbleStepOrigin("CreateMissionWorkingAddress");

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.translate("next"),
                    onPress: validate,
                    isValid: !!mission.currentContract?.workingAddress,
                },
            ]}
            withAssistanceButton
        >
            <Bubble
                title={i18n.t("screens.user.create_mission_working_address.title")}
                bubbleStyle={{ paddingBottom: 0 }}
                origin={origin}
            >
                <MissionWorkingAddress
                    mission={mission}
                    setWorkingAddress={setWorkingAddress}
                ></MissionWorkingAddress>
            </Bubble>
        </ScreenCard>
    );
};

export default CreateMissionWorkingAddress;
